import React, { useMemo } from 'react';
import { FixedSizeList, FixedSizeListProps, ListChildComponentProps } from 'react-window';
import ListItem from './ListItem';
import { usePageStore } from '@/features/pages/stores/usePageStore';
import Spinner from '@/shared/components/ui/spinner';

const ListContainer = () => {
  const pagesMetadata = usePageStore(page => page.pagesMetadata);
  const loading = usePageStore(page => page.isPageListLoading);
  const filteredPages = useMemo(
    () => pagesMetadata.filter(metadata => !!metadata.id),
    [pagesMetadata]
  );

  const height = useMemo(() => {
    // h-[calc(100vh-300px)
    return window.innerHeight - 300;
  }, []);

  // Render an empty message component
  const emptyMessage = useMemo(() => {
    if (filteredPages.length === 0) {
      return <span className="text-sm text-muted-foreground px-4 pt-3">Add more notes here</span>;
    }
    return null;
  }, [filteredPages.length]);

  const Row = ({ index, style }: ListChildComponentProps) => {
    const metadata = filteredPages[index];
    return (
      <div style={style}>
        <ListItem metadata={metadata} />
      </div>
    );
  };

  if (loading && !filteredPages.length) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner size={26} />
      </div>
    );
  }

  const List = FixedSizeList as unknown as React.ComponentType<FixedSizeListProps<unknown>>;

  return (
    <>
      {!loading && emptyMessage}
      {filteredPages.length > 0 && (
        <List
          height={height}
          width="100%"
          itemCount={filteredPages.length}
          itemSize={40} // Default height for each item
          overscanCount={5} // Number of items to render outside of the visible area
        >
          {Row}
        </List>
      )}
    </>
  );
};

export default React.memo(ListContainer);
